import { useEffect, useState, useCallback } from "react";
import api from "../../utils/api";
import PostCommentInput from "./PostCommentInput";
import PostCommentItem from "./PostCommentItem";

export default function PostComments({
  postId,
  currentUser,
  onCommentAdded,
}) {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= LOAD COMMENTS ================= */

  const load = useCallback(async () => {
    if (!postId) return;

    try {
      setLoading(true);

      const res = await api.get("/api/comments", {
        params: { postId },
      });

      const fetched = res.data?.data || [];
      setComments(fetched);

    } catch (err) {
      console.error("Failed to load comments:", err);
      setComments([]);
    } finally {
      setLoading(false);
    }
  }, [postId]);

  useEffect(() => {
    load();
  }, [load]);

  /* ================= HANDLE NEW COMMENT ================= */

  const handleSuccess = (newComment) => {
    if (newComment) {
      // Optimistic add (no reload)
      setComments((prev) => [...prev, newComment]);
    } else {
      load(); // fallback if backend didn't return comment
    }

    if (onCommentAdded) {
      onCommentAdded(postId);
    }
  };

  /* ================= RENDER ================= */

  return (
    <div className="comments-wrapper">

      {/* TITLE */}
      <div className="comments-title">
        Comments ({comments.length})
      </div>

      {/* COMMENTS LIST */}
      <div className="comments-list">

        {loading && (
          <div className="comment-loading">
            Loading comments...
          </div>
        )}

        {!loading && comments.length === 0 && (
          <div className="comment-empty">
            No comments yet
          </div>
        )}

        {!loading &&
          comments.map((c) => (
            <PostCommentItem
              key={c._id}
              data={c}
              currentUser={currentUser}
              onAction={load}
            />
          ))}

      </div>

      {/* INPUT AT BOTTOM */}
      {currentUser ? (
        <PostCommentInput
          postId={postId}
          onSuccess={handleSuccess}
        />
      ) : (
        <div className="comment-login-msg">
          Login to comment
        </div>
      )}

    </div>
  );
}
